import DOMPurify from 'dompurify';

export function supportedEmbed(src) {
  try {
    const url = new URL(src);
    return (
      url.protocol === 'https:' &&
      ((['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com'].includes(
        url.hostname
      ) &&
        url.pathname.startsWith('/embed/')) ||
        (url.hostname === 'player.vimeo.com' &&
          url.pathname.startsWith('/video/')))
    );
  } catch (_) {
    return false;
  }
}

export function renderableHtml(html) {
  const purifier = DOMPurify.sanitize ? DOMPurify : DOMPurify(window);
  const safe = purifier.sanitize(html, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allowfullscreen'],
    FORBID_TAGS: ['script', 'form', 'input', 'button', 'style', 'link'],
    FORBID_ATTR: ['srcdoc'],
  });
  const doc = new DOMParser().parseFromString(safe, 'text/html');
  doc.querySelectorAll('iframe').forEach((frame) => {
    if (!supportedEmbed(frame.getAttribute('src'))) {
      frame.remove();
      return;
    }
    frame.setAttribute(
      'sandbox',
      'allow-scripts allow-same-origin allow-presentation'
    );
    frame.setAttribute('loading', 'lazy');
    frame.style.maxWidth = '100%';
  });
  return doc.body.innerHTML;
}
